import React, { useEffect, useState } from 'react';

import API from 'service/api';
import { Data } from 'service/util';

import PopMessage from 'component/pop-msg/PopMessage';
import Protected from './Protected';

const VehicleEdit = ({ vehicle, onDeleted, ...props }) =>
{

  const [vh_type, setVehicleType] = useState(vehicle?.vh_type);
  const [source,  setSource]      = useState(vehicle?.source);
  const [color,   setColor]       = useState(vehicle?.color);
  const [brand,   setBrand]       = useState(vehicle?.brand);
  const [model,   setModel]       = useState(vehicle?.model);
  const [remarks, setRemarks]     = useState(vehicle?.remarks);

  const updateVehicle = () =>
  {
    let vehicleDto = {
      ...vehicle, vh_type, source, color, brand, model, remarks
    };

    API.editVehicle(vehicleDto).then(resp => {
      if (!resp.success) {
        PopMessage.show(resp.msg, '存取失敗', 'danger');
      } else {
        PopMessage.show('成功更新車輛資料', '成功', 'success');
      }
    });
  }
  const hideVehicle = () =>
  {
    let { owner_id, cd_license } = vehicle;
    let dto = { owner_id, cd_license };
    if (window.confirm(`此操作無法復原。確定要移除車輛[ ${cd_license} ]嗎？`))
    {
      API.deleteVehicle(dto).then(resp => {
        if (!resp.success) {
          PopMessage.show(resp.msg, '存取失敗', 'danger');
        } else {
          PopMessage.show('已移除車輛', '成功', 'success');
          onDeleted(resp.msg);
        }
      });
    }
  }

  useEffect(() => {
    setVehicleType(vehicle?.vh_type);
    setSource(vehicle?.source);
    setColor(vehicle?.color);
    setBrand(vehicle?.brand);
    setModel(vehicle?.model);
    setRemarks(vehicle?.remarks);
  }, [vehicle]);

  return (
    <div className="box op-vehicle-info">
      <h4 className="box-head">{ vehicle.cd_license }</h4>
      <div className="box-body">
        <div>
          <label className="field">
            <strong>車種</strong>
            <select value={vh_type} onChange={e=>setVehicleType( parseInt(e.target.value,10) )}>
              { Data.vtype.map(vt =>
                <option key={vt.id} value={vt.id}>{vt.id} - {vt.desc}</option>
              )}
            </select>
          </label>
          <label className="field">
            <strong>客戶來源</strong>
            <select value={source} onChange={e=>setSource( parseInt(e.target.value,10) )}>
              <option value={0}></option>
              <option value={1}>傳單</option>
              <option value={2}>工人介紹</option>
              <option value={3}>優悠家居</option>
              <option value={4}>合拼</option>
            </select>
          </label>
          <label className="field">
            <strong>顏色</strong>
            <input value={color} onChange={e=>setColor(e.target.value)} />
          </label>
          <label className="field">
            <strong>品牌</strong>
            <input value={brand} onChange={e=>setBrand(e.target.value)} list="ls-brand" />
            <datalist id="ls-brand">
              { Data.brand.map(b =>
                <option key={`brand-${b.name_en}`} value={b.name_en}>{b.name_zh}</option>
              )}
            </datalist>
          </label>
          <label className="field">
            <strong>型號</strong>
            <input value={model} onChange={e=>setModel(e.target.value)} />
          </label>
        </div>
        <label className="field">
          <strong>備註</strong>
          <textarea className="s-remarks" value={remarks||''}
            onChange={e=>setRemarks(e.target.value)}
            onBlur={e=>setRemarks(e.target.value.trim()||null)}>
          </textarea>
        </label>
        <div className="action-panel">
          <div className="button-group">
            <Protected allow={['ADMIN']}>
            { !vehicle.deleted &&
              <button className="btn red" onClick={hideVehicle}>移除 [ {vehicle.cd_license} ]</button>
            }
            </Protected>
          </div>
          <Protected allow={['ADMIN','OPERATOR']}>
            <button className="btn blue" onClick={updateVehicle}>儲存</button>
          </Protected>
        </div>
      </div>
    </div>
  );
}

export default VehicleEdit;